import { faqHeading } from "@/lib/article-variation";

type Props = {
  items: { q: string; a: string }[];
  /** Article slug — varies the heading wording deterministically per article. */
  slug?: string;
  /** Explicit heading override; wins over the slug-derived variant. */
  heading?: string;
};

export function ArticleFaq({ items, slug, heading }: Props) {
  if (!items?.length) return null;
  const title = heading ?? (slug ? faqHeading(slug) : "Frequently Asked Questions");
  return (
    <section
      aria-label="Frequently asked questions"
      className="mt-8 rounded-2xl border border-border bg-muted/30 p-6"
    >
      <h3 id="faq" className="!mt-0 font-display text-2xl font-bold text-foreground">
        {title}
      </h3>
      <div className="mt-4 space-y-4">
        {items.map((f, i) => (
          <details
            key={i}
            className="group rounded-lg border border-border bg-card p-4 open:shadow-sm"
          >
            <summary className="cursor-pointer list-none font-semibold text-foreground marker:hidden">
              <span className="mr-2 text-accent">Q.</span>
              {f.q}
            </summary>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}

export default ArticleFaq;
